module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp13_5012.93f61cb3.png";